import SearchIcon from "@mui/icons-material/Search";
import { FormattedMessage, useIntl } from "react-intl";
import { AsyncTypeahead } from "react-bootstrap-typeahead"; // ES2015
import "./typeAHeadSearchComponent.scss";

import { Col, Row, Spinner } from "react-bootstrap";
const TypeAHeadSearchComponent = ({
  isLoading = false,
  fetchingData = [],
  onSearchTermChange,
  onKeyDown,
  currentValue = "",
  autoFocus,
}) => {
  const intl = useIntl();

  return (
    <Row className="type-ahead-search-bar">
      <Col xs={11} className="typeahead-single-input">
        <AsyncTypeahead
          key={`typeahead-${currentValue || ""}`}
          id="basic-typeahead-single"
          labelKey={(option) => {
            return option.title;
          }}
          filterBy={(option) => {
            return option.id.toString();
          }}
          autoFocus={autoFocus || false}
          isLoading={false}
          options={fetchingData}
          onSearch={onSearchTermChange}
          defaultInputValue={currentValue || ""}
          onKeyDown={onKeyDown}
          placeholder={intl.formatMessage({ id: "search" })}
          emptyLabel={intl.formatMessage({ id: "data-not-found" })}
          renderMenuItemChildren={(option) => {
            return (
              <div
                style={{
                  fontStyle: "italic",
                  fontSize: "80%",
                  textAlign: "start",
                }}
              >
                {option.title}
              </div>
            );
          }}
        />
      </Col>
      <Col xs={1} className="suffix-component">
        {isLoading ? (
          <Spinner
            animation="border"
            style={{
              width: "22px",
              height: "22px",
            }}
          />
        ) : (
          <SearchIcon />
        )}
      </Col>
    </Row>
  );
};

export default TypeAHeadSearchComponent;
